(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      new Promise(resolve => setTimeout(resolve, 2100))
        .then(() => {
          const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

          window.addEventListener('scroll', () => {
            if (window.scrollY > top) {
              this.classList.add('show')
              document.body.style.paddingBottom = this.clientHeight + 'px'
            } else {
              this.classList.remove('show')
              document.body.style.paddingBottom = 0
            }
          })

          const btnOptions = this.querySelector('.ks-sticky-atc-btn-choose-options')

          btnOptions?.addEventListener('click', (e) => {
            document.querySelector('product-info').scrollIntoView({
              behavior: 'smooth'
            })
          })
        })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-testimonial"] && !Shopify.designMode) return;
  try {
    
class KsTestimonialsSlider extends HTMLElement {
  constructor () {
    super()

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    setTimeout(() => {
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())
    }, 500)
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
    return options
  }
}
customElements.define('ks-testimonials-slider', KsTestimonialsSlider)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-whatsapp"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
